import $ from "jquery";
import global_table_toggle_methods from "./global_table_toggle_methods";

function reset_scroll_position(scroll_container) {
  if (scroll_container?.scrollLeft !== 0) {
    scroll_container.scrollLeft = 0;
  }
}

export default {
  destroy_data_table() {
    const table_id = `#${this.table_id}`;
    if (!$.fn.DataTable.isDataTable(table_id)) {
      return;
    }
    $(table_id).DataTable().clear().destroy();
  },

  get_table_element() {
    return document.getElementById(this.table_id);
  },

  get_column_elements(column_id) {
    const table_element = this.get_table_element();
    if (!table_element || !column_id) {
      return [];
    }
    return Array.from(table_element.querySelectorAll(`[data-col="${column_id}"]`));
  },

  get_table_fit_context() {
    const table_element = this.get_table_element();
    const context = {
      table_element,
      scroll_container: table_element?.closest(".custom-scroll-container"),
      responsive_container: table_element?.closest(".table-responsive"),
    };
    return context;
  },

  table_fit_context_is_ready(context) {
    return !!(context.table_element && context.scroll_container && context.responsive_container);
  },

  should_lock_table_fit(table_element, scroll_container) {
    return table_element.scrollWidth <= scroll_container.clientWidth || this.get_visible_table_column_count() <= 3;
  },

  update_table_fit_state() {
    const context = this.get_table_fit_context();
    if (!this.table_fit_context_is_ready(context)) {
      this.table_fits_container = false;
      return;
    }
    const { table_element, scroll_container, responsive_container } = context;
    const fits_container = this.should_lock_table_fit(table_element, scroll_container);

    this.table_fits_container = fits_container;
    this.apply_fit_layout_styles(table_element, scroll_container, responsive_container, fits_container);
    if (fits_container) reset_scroll_position(scroll_container);
  },

  apply_fit_layout_styles(table_element, scroll_container, responsive_container, should_lock) {
    const data_table_wrapper = table_element.closest(".dataTables_wrapper");
    const data_table_scroll = data_table_wrapper?.querySelector(".dataTables_scroll");
    const data_table_scroll_head = data_table_wrapper?.querySelector(".dataTables_scrollHead");
    const data_table_scroll_body = data_table_wrapper?.querySelector(".dataTables_scrollBody");
    const colgroups = Array.from(table_element.querySelectorAll("colgroup"));

    if (should_lock) {
      this.lock_fit_layout(
        table_element,
        scroll_container,
        responsive_container,
        data_table_scroll,
        data_table_scroll_head,
        data_table_scroll_body,
        colgroups
      );
      return;
    }

    this.unlock_fit_layout(
      table_element,
      scroll_container,
      responsive_container,
      data_table_scroll,
      data_table_scroll_head,
      data_table_scroll_body,
      colgroups
    );
  },

  lock_fit_layout(table_element, scroll_container, responsive_container, data_table_scroll, data_table_scroll_head, data_table_scroll_body, colgroups) {
    scroll_container.style.overflowX = "hidden";
    responsive_container.style.overflowX = "hidden";
    responsive_container.style.width = "100%";
    table_element.style.setProperty("width", "100%", "important");
    table_element.style.setProperty("min-width", "100%", "important");
    table_element.style.setProperty("max-width", "100%", "important");
    table_element.style.tableLayout = "fixed";
    if (data_table_scroll) {
      data_table_scroll.style.overflowX = "hidden";
      data_table_scroll.style.width = "100%";
    }
    if (data_table_scroll_head) {
      data_table_scroll_head.style.overflowX = "hidden";
    }
    if (data_table_scroll_body) {
      data_table_scroll_body.style.overflowX = "hidden";
    }
    colgroups.forEach((colgroup) => {
      colgroup.style.display = "none";
    });
    this.apply_visible_column_widths(table_element);
  },

  unlock_fit_layout(table_element, scroll_container, responsive_container, data_table_scroll, data_table_scroll_head, data_table_scroll_body, colgroups) {
    scroll_container.style.overflowX = "";
    responsive_container.style.overflowX = "";
    responsive_container.style.width = "";
    table_element.style.removeProperty("width");
    table_element.style.removeProperty("min-width");
    table_element.style.removeProperty("max-width");
    table_element.style.tableLayout = "auto";
    if (data_table_scroll) {
      data_table_scroll.style.overflowX = "";
      data_table_scroll.style.width = "";
    }
    if (data_table_scroll_head) {
      data_table_scroll_head.style.overflowX = "";
    }
    if (data_table_scroll_body) {
      data_table_scroll_body.style.overflowX = "";
    }
    colgroups.forEach((colgroup) => {
      colgroup.style.display = "";
    });
    this.clear_visible_column_widths(table_element);
  },

  apply_visible_column_widths(table_element) {
    const header_row = table_element.querySelector("thead tr");
    if (!header_row) {
      return;
    }

    const visible_header_cells = Array.from(header_row.children).filter((cell) => {
      return window.getComputedStyle(cell).display !== "none";
    });

    if (!visible_header_cells.length) {
      return;
    }

    const width_percent = `${100 / visible_header_cells.length}%`;
    const visible_column_indexes = visible_header_cells.map((cell) =>
      Array.from(cell.parentElement.children).indexOf(cell)
    );

    visible_header_cells.forEach((cell) => {
      cell.style.setProperty("width", width_percent, "important");
      cell.style.setProperty("min-width", "0", "important");
      cell.style.setProperty("max-width", "none", "important");
      cell.style.whiteSpace = "normal";
      cell.style.overflowWrap = "anywhere";
      cell.style.wordBreak = "break-word";
    });

    const body_rows = Array.from(table_element.querySelectorAll("tbody tr"));
    body_rows.forEach((row) => {
      visible_column_indexes.forEach((column_index) => {
        const cell = Reflect.get(row.children, column_index);
        if (!cell || window.getComputedStyle(cell).display === "none") {
          return;
        }

        cell.style.setProperty("width", width_percent, "important");
        cell.style.setProperty("min-width", "0", "important");
        cell.style.setProperty("max-width", "none", "important");
        cell.style.whiteSpace = "normal";
        cell.style.overflowWrap = "anywhere";
        cell.style.wordBreak = "break-word";
      });
    });
  },

  clear_visible_column_widths(table_element) {
    const cells = table_element.querySelectorAll("thead th, tbody td");
    cells.forEach((cell) => {
      cell.style.removeProperty("width");
      cell.style.removeProperty("min-width");
      cell.style.removeProperty("max-width");
      cell.style.removeProperty("white-space");
      cell.style.removeProperty("overflow-wrap");
      cell.style.removeProperty("word-break");
    });
  },

  set_column_visibility(column_id, should_show) {
    this.get_column_elements(column_id).forEach((element) => {
      element.style.display = should_show ? "" : "none";
    });
  },

  refresh_horizontal_scroll() {
    const context = this.get_table_fit_context();
    if (!context.table_element) return;
    if (this.table_fit_context_is_ready(context)) {
      this.apply_fit_layout_styles(context.table_element, context.scroll_container, context.responsive_container, false);
    }

    const dt = $(context.table_element).DataTable();
    if (dt) dt.columns.adjust();
    requestAnimationFrame(() => {
      this.update_table_fit_state();
      requestAnimationFrame(() => {
        this.update_table_fit_state();
      });
    });
  },

  ...global_table_toggle_methods,
};
